import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PrintReciptComponent } from './print-recipt.component';
import { PrintRecipt2Component } from './print-recipt2/print-recipt2.component';
import { DeliveryReportComponent } from './delivery-report/delivery-report.component';
import { DeliveryReportBulkComponent } from './delivery-report-bulk/delivery-report-bulk.component';

const routes: Routes = [
  {path:"print/:id",component:PrintReciptComponent},
  {path:"print2/:id",component:PrintRecipt2Component},
  {path:"delivery-report/:id",component:DeliveryReportComponent},
  {path:'delivery-report-bulk',component:DeliveryReportBulkComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PrintReciptRoutingModule { }
